<template>
  <form class="border rounded p-3" @submit.prevent="handleForm">
    <legend>Filters</legend>
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label for="clients">Client</label>
          <select
            name="clients"
            v-model="clients"
            size="6"
            multiple
            class="form-control"
          >
            <option
              v-for="client in clientList"
              :key="client.client_id"
              :value="client.client_id"
              >{{ client.client_name }}</option
            >
          </select>
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <label for="userType">Admin</label>
          <select name="userType" v-model="userType" class="form-control">
            <option :value="1">Users</option>
            <option :value="2">Admins</option>
            <option :value="0">All</option>
          </select>
        </div>
        <div class="form-group">
          <label for="lockStatusType">Locked</label>
          <select
            name="lockStatusType"
            v-model="lockStatusType"
            class="form-control"
          >
            <option :value="2">Active</option>
            <option :value="1">Locked</option>
            <option :value="0">All</option>
          </select>
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <label for="search"
            >Enter Id, Name, Username or SSN, clear text &amp; click search to
            remove search.</label
          >
          <input
            type="text"
            name="searchTerm"
            v-model="searchTerm"
            size="10"
            class="form-control"
          />
        </div>
        <div class="form-group">
          <label class="hidden-sm hidden-xs">&nbsp;</label>
          <div class="clearfix"></div>
          <input
            type="Submit"
            name="submit"
            value="Search"
            class="btn btn-primary"
          />
        </div>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: "UsersFilters",
  data() {
    return {
      userType: 0,
      lockStatusType: 0,
      searchTerm: "",
      clients: [],
    };
  },
  computed: {
    clientList() {
      return this.$store.getters["manageUsers/getClientList"];
    },
    getLockStatusType() {
      return this.$store.getters["manageUsers/getLockStatusType"];
    },
    getUserType() {
      return this.$store.getters["manageUsers/getUserType"];
    },
    getClients() {
      return this.$store.getters["manageUsers/getClients"];
    },
    getSearchTerm() {
      return this.$store.getters["manageUsers/getSearchTerm"];
    },
  },
  methods: {
    handleForm() {
      this.$store.dispatch("manageUsers/setFormData", {
        clients: this.clients,
        userType: Number(this.userType),
        lockStatusType: Number(this.lockStatusType),
        searchTerm: this.searchTerm,
      });
      this.$store.dispatch("manageUsers/fetchGetUsers");
    },
    setFilterData() {
      this.userType = this.getUserType;
      this.lockStatusType = this.getLockStatusType;
      this.searchTerm = this.getSearchTerm;
      this.clients = this.getClients;
    },
  },
  mounted() {
    this.$store.dispatch("manageUsers/fetchGetUserClients");
    this.setFilterData();
  },
};
</script>

